export default __webpack_public_path__ + "static/media/flag-brunei-darussalam.9a65ab6d.svg";